import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';


// Load Icons
import { defineLordIconElement } from 'lord-icon-element';
import lottie from 'lottie-web';

// Pages Routing
import { PagesRoutingModule } from "./pages-routing.module";
import { SharedModule } from "../shared/shared.module";

@NgModule({
  declarations: [
  ],
  imports: [

    LeafletModule,
    PagesRoutingModule,
    SharedModule,

  ],
  providers: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule {
  constructor() {
    defineLordIconElement(lottie.loadAnimation);
  }
}
